import { render, staticRenderFns } from "./StatisticsBar.vue?vue&type=template&id=034ae0be&scoped=true&"
import script from "./StatisticsBar.vue?vue&type=script&lang=js&"
export * from "./StatisticsBar.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsBar.vue?vue&type=style&index=0&id=034ae0be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034ae0be",
  null
  
)

export default component.exports